import cn from 'classnames';

import PageHeader from './PageHeader';

interface StepHeaderProps {
  stepNumber: number;
  title: string;
  subtitle: string;
}

interface StepProps extends StepHeaderProps {
  className?: string;
}

function StepHeader({ stepNumber, title, subtitle }: StepHeaderProps) {
  return (
    <PageHeader
      title={
        <h2 className="text-2xl font-bold sm:text-3xl leading-7 sm:text-4xl sm:truncate">
          {title}
        </h2>
      }
      subtitle={`Step ${stepNumber}: ${subtitle}`}
    />
  );
}

export default function Step({
  stepNumber,
  title,
  subtitle,
  children,
  className,
}: StepProps & { children: any }) {
  return (
    <div className={cn('max-w-2xl mx-auto', className)}>
      <StepHeader stepNumber={stepNumber} title={title} subtitle={subtitle} />
      {children}
    </div>
  );
}
